import { Button } from '@/shared/ui/primitives';
import type { FC } from 'react';
import { TrashIcon } from './icons/TrashIcon';
import { destructiveButtonClass } from './ModalFooter';

interface ModalDeleteButtonProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  testId?: string;
}

export const ModalDeleteButton: FC<ModalDeleteButtonProps> = ({
  label,
  onClick,
  disabled,
  testId,
}) => (
  <Button
    variant="ghost"
    onClick={onClick}
    disabled={disabled}
    fullWidth
    leading={<TrashIcon />}
    className={destructiveButtonClass}
    data-testid={testId}
  >
    {label}
  </Button>
);
